module.exports = __webpack_public_path__ + "assets/img/course_math_start.dc39bc06.jpg";